import {createAction} from 'redux-actions';
import {getQcReportsReasons} from '@pluto/rest';
import {NoteType} from '@pluto/@types';

export const QC_REPORTS_REASONS_SET = 'QC_REPORTS_REASONS_SET';
export const QC_REPORTS_REASONS_RESET = 'QC_REPORTS_REASONS_RESET';

export const setQcReportsReasonsAction = createAction(QC_REPORTS_REASONS_SET, async (type: NoteType) => {
    return await getQcReportsReasons(type);
});

export const resetQcReportReasonsAction = createAction(QC_REPORTS_REASONS_RESET);
